module.exports = __webpack_public_path__ + "img/cs3.b7210867.jpg";